import React, { PureComponent } from 'react'
import { universalOpenUrl } from '~/utils'
import styles from './styles.css'

export default class InnerBanner extends PureComponent {
  handleClick = () => universalOpenUrl(this.props.url)
  render() {
    const bannerSize = {
      width: document.body.clientWidth,
      height: document.body.clientWidth / 375 * 156,
    }
    const { wrap } = styles
    return (
      <div className={wrap} onClick={this.handleClick}>
        <img src={this.props.img} alt="" style={bannerSize} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/InnerBanner/index.js